import axios from "../http"; // 导入axios实例
import qs from "qs"; // 根据需求是否导入qs模块

const getShop ={
    getGroupUser(params) {
        //商品拼团详情
        return axios.post("/mobile/group/info", qs.stringify(params));
    },
    getShopDetails(params) {
        return axios.post(`/mobile/product/pc_info`, qs.stringify(params));
    },
    //评论数据
    getShopDetails1(params) {
        return axios.post(`/mobile/product_review/lists`, qs.stringify(params));
    },
    getProduct(params) {
        return axios.post(`/mobile/page/tuijian_and_see`, qs.stringify(params));
    },
    getSonAllCate(params) {
        return axios.post(`/mobile/page/son_all_cate`, qs.stringify(params));
    },
    getSearchCateProduct(params) {
        return axios.post(`/mobile/page/search_cate_product`, qs.stringify(params));
    },
    getSearchShopHot(params) {
        return axios.post(`/mobile/page/search_shop_hot`, qs.stringify(params));
    },
    getXianshiMiaoshaHot(params) {
        return axios.post(`/mobile/page/xianshi_and_miaosha`, qs.stringify(params));
    },
    getBzzn(params) {
        return axios.post(`/mobile/page/bizhenzhinan`, qs.stringify(params));
    },
    getBcsq(params) {
        return axios.post(`/mobile/page/baochuishenqi`, qs.stringify(params));
    },
    getGdcj(params) {
        return axios.post(`/mobile/page/gdianciji`, qs.stringify(params));
    },
    getJqtd(params) {
        return axios.post(`/mobile/page/jiqingtiaodan`, qs.stringify(params));
    },
    getFuzzySearch(params) {
        return axios.post(`/mobile/page/fuzzy_search`, qs.stringify(params));
    },
    getKeywordsCateProduct(params) {
        return axios.post(`/mobile/page/keywords_cate_product`, qs.stringify(params));
    },
    getHistory(params) {
        return axios.post(`/mobile/product/search`, qs.stringify(params));
    },
    //添加到购物车
    addCart(params) {
        return axios.post(`/mobile/page/add_cart`, qs.stringify(params));
    },
    //购物车数量
    getCardNumber(params) {
        return axios.post(`/mobile/page/number`, qs.stringify(params));
    },
    //购物车列表
    getCartList(params) {
        return axios.post(`/mobile/page/lists`, qs.stringify(params));
    },
    //购物车列表
    updateCardNumber(params) {
        return axios.post(`/mobile/page/cart_num`, qs.stringify(params));
    },
    get_carnum(params) {
        return axios.post("/mobile/page/cart_number", qs.stringify(params));
    },
    delCard(params) {
        return axios.post(`/mobile/page/del_all`, qs.stringify(params));
    },
    //添加到结算订单
    addOrder(params) {
        return axios.post(`/mobile/page/confirm_order`, qs.stringify(params));
    },
    //iden
    getIden(params) {
        return axios.post(`/mobile/page/product_sku_iden`, qs.stringify(params));
    },
    //sku_title
    getSkuTitle(params) {
        return axios.post(`/mobile/page/sku_title`, qs.stringify(params));
    },
    //限时抢购
    getXianshiqianggou(params) {
        return axios.post(`/mobile/page/limited_time`, qs.stringify(params));
    },
    //限时抢购列表
    getXsqgList(params) {
        return axios.post(`/mobile/page/limited_time_lists`, qs.stringify(params));
    },
    //每日特价的时间
    getEveryday(params) {
        return axios.post(`/mobile/page/everyday_limited_time`, qs.stringify(params));
    },
    //每日特价列表
    getEverydayList(params) {
        return axios.post(`/mobile/page/everyday_time_lists`, qs.stringify(params));
    },
    //每个时间点列表
    getOnlyTimeList(params) {
        return axios.post(`/mobile/page/only_time_list`, qs.stringify(params));
    },
    //优惠券
    getCoupon(params) {
        return axios.post(`/mobile/page/pc_packet_list`, qs.stringify(params));
    },
    //优惠券
    getGudingCoupon(params) {
        return axios.post(`/mobile/page/pc_guding_packet_list`, qs.stringify(params));
    },
    getLingquCoupon(params) {
        return axios.post(`/mobile/page/receive`,qs.stringify(params));
    },
    coupon_packet_ye(params) {
        return axios.post(`mobile/page/packet_ye`, qs.stringify(params));
    },
    exchange_mark(params) {
        return axios.post("/mobile/page/packet_jf", qs.stringify(params));
    },
    //热门推荐
    getHotProduct(params) {
        return axios.post(`/mobile/page/pc_hot_product`, qs.stringify(params));
    },
    //收藏
    get_collect_news(params){
        return axios.post(`/mobile/page/news_collect_lists`, qs.stringify(params));
    },
    //收藏
    getFav(params){
        return axios.post(`/mobile/page/product_collect_lists`, qs.stringify(params));
    },
    //收藏
    getFavs(params){
        return axios.post(`/mobile/page/product_collect_listss`, qs.stringify(params));
    },
    //天天特价
    getPintuan(params){
        return axios.post(`/mobile/group/lists`, qs.stringify(params));
    },
    //秒杀详情
    getMsDetail(params){
        return axios.post(`/mobile/product/pc_miaosha_info`, qs.stringify(params));
    },
    //特价详情
    getTjDetail(params){
        return axios.post(`/mobile/product/pc_tj_info`, qs.stringify(params));
    },
    getQualityDetails(params) {
        return axios.post(`/mobile/quality_product/info`, qs.stringify(params));
    },
    //支付列表
    getOrderPay(params) {
        return axios.post(`/mobile/page/pay_list_all`, qs.stringify(params));
    },
    getGz(params) {
        return axios.post(
          // 收藏商品
          `/mobile/page/product_collect`,
          qs.stringify(params)
        );
      },
      getConfigData(params){
        return axios.post(`/mobile/page/config_data`, qs.stringify(params));
    },
    //避孕套所有产品
    getBYTAllProuduct(params) {
        return axios.post(`/mobile/page/taotao_all_product`, qs.stringify(params));
    },

    //避孕套按销量所有产品
    getBYTXLAllProuduct(params) {
        return axios.post(`/mobile/page/taotao_xl_all_product`, qs.stringify(params));
    },
    //避孕套按价格降序所有产品
    getBYTPriceAllProuduct(params) {
        return axios.post(`/mobile/page/taotao_price_all_product`, qs.stringify(params));
    },
    //避孕套按价格升序所有产品
    getBYTPriceAscAllProuduct(params) {
        return axios.post(`/mobile/page/taotao_price_asc_all_product`, qs.stringify(params));
    },

    //双人情趣所有产品
    getSRQQAllProuduct(params) {
        return axios.post(`/mobile/page/srqq_all_product`, qs.stringify(params));
    },

    //双人情趣按销量所有产品
    getSRQQXLAllProuduct(params) {
        return axios.post(`/mobile/page/srqq_xl_all_product`, qs.stringify(params));
    },
    //双人情趣按价格所有产品
    getSRQQPriceAllProuduct(params) {
        return axios.post(`/mobile/page/srqq_price_all_product`, qs.stringify(params));
    },
    //双人情趣按价格升序所有产品
    getSRQQPriceAscAllProuduct(params) {
        return axios.post(`/mobile/page/srqq_price_asc_all_product`, qs.stringify(params));
    },

    //情趣内衣所有产品
    getQQNYAllProuduct(params) {
        return axios.post(`/mobile/page/qqny_all_product`, qs.stringify(params));
    },

    //情趣内衣按销量所有产品
    getQQNYXLAllProuduct(params) {
        return axios.post(`/mobile/page/qqny_xl_all_product`, qs.stringify(params));
    },
    //情趣内衣按价格降序所有产品
    getQQNYPriceAllProuduct(params) {
        return axios.post(`/mobile/page/qqny_price_all_product`, qs.stringify(params));
    },
    //情趣内衣按价格升序所有产品
    getQQNYPriceAscAllProuduct(params) {
        return axios.post(`/mobile/page/qqny_price_asc_all_product`, qs.stringify(params));
    },

    //延时助情所有产品
    getYSZQAllProuduct(params) {
        return axios.post(`/mobile/page/yszq_all_product`, qs.stringify(params));
    },

    //延时助情所有产品(按销量排序)
    getYSZQXLAllProuduct(params) {
        return axios.post(`/mobile/page/yszq_xl_all_product`, qs.stringify(params));
    },
    //延时助情所有产品(按价格排序)
    getYSZQPriceAllProuduct(params) {
        return axios.post(`/mobile/page/yszq_price_all_product`, qs.stringify(params));
    },
    //延时助情所有产品(按价格排序升序)
    getYSZQPriceAscAllProuduct(params) {
        return axios.post(`/mobile/page/yszq_price_asc_all_product`, qs.stringify(params));
    },
}
export default getShop;


// WEBPACK FOOTER //
// ./src/assets/js/api/require/shop.js